'use client'

import { Mail, Phone, Sparkles } from 'lucide-react'
import { getVendorPhones } from '@/utils/vendorPhones'

export default function SubHeader({ vendor }: { vendor?: any }) {
  const banner = vendor?.headBanner
  const phones = getVendorPhones(vendor)
  const showSecondary = phones.length > 0 || vendor?.email
  if (!banner && !showSecondary) return null

  return (
    <div
      className="text-[11px]"
      style={{ background: 'rgba(8,8,10,0.95)', color: 'rgba(255,255,255,0.55)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}
    >
      <div className="mx-auto w-full max-w-[1280px] px-4 lg:px-8 min-h-9 py-1.5 md:py-0 flex items-center justify-center md:justify-between gap-4">
        <div className="flex items-center gap-5 min-w-0 justify-center md:justify-start">
          {banner ? (
            <span className="inline-flex items-center gap-2 font-medium min-w-0 text-center md:text-left">
              <span className="relative w-1.5 h-1.5 shrink-0">
                <span className="absolute inset-0 rounded-full bg-emerald-400" />
                <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping" />
              </span>
              <span className="truncate">{banner}</span>
            </span>
          ) : (
            <span className="inline-flex items-center gap-1.5 font-medium">
              <Sparkles className="h-3 w-3 shrink-0" style={{ color: '#a8a8b3' }} />
              <span style={{ color: 'rgba(255,255,255,0.7)' }}>{vendor?.name || 'Shop.mn'}</span>
            </span>
          )}
        </div>
        <div className="hidden md:flex items-center gap-5 shrink-0">
          {phones.length > 0 && (
            <span className="inline-flex items-center gap-1.5">
              <Phone className="h-3 w-3" />
              <span>
                {phones.map((p, i) => (<span key={p}>{i > 0 && ', '}<a href={`tel:${p}`} className="hover:text-white transition-colors">{p}</a></span>))}
              </span>
            </span>
          )}
          {phones.length > 0 && vendor?.email && <span style={{ opacity: 0.4 }}>·</span>}
          {vendor?.email && (
            <a href={`mailto:${vendor.email}`} className="inline-flex items-center gap-1.5 hover:text-white transition-colors max-w-70 min-w-0">
              <Mail className="h-3 w-3 shrink-0" />
              <span className="truncate">{vendor.email}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
